



























import { Component, Prop } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import { PartnerListRequest } from "@/models/partner";
import List from "@/components/basic/List.vue";
import { IPagination } from "@/types";
import { IStaff, IStaffListRequest } from "@/types/staff";

@Component({ components: {} })
export default class extends List {
  @Action("staff/salesGetList")
  public staffGetList!: (datas: {
    partner_id: number;
    params: IStaffListRequest;
  }) => boolean;

  @Getter("staff/list")
  public staffList!: IStaff[];

  @Getter("staff/pagination")
  public pagination!: IPagination<IStaff>;

  @Mutation("staff/clear")
  public clear!: () => void;

  @Prop()
  public search!: string;

  public headers = [
    {
      text: "name",
      align: "start",
      value: "name",
    },
    { text: "email", value: "email" },
    { text: "tel", value: "tel" },
  ];

  public params = new PartnerListRequest();

  public partner_id = 0;

  public created(): void {
    this.partner_id = Number(this.$route.params.partner_id);
  }

  // override
  public async getList(): Promise<void> {
    this.loading = true;
    this.params.page = 1;
    await this.staffGetList({
      partner_id: this.partner_id,
      params: this.params,
    });
    this.loading = false;

    this.paramsToQuery();
  }

  public rowClick(staff: IStaff): void {
    this.$router.push({
      name: "SalesStaffEdit",
      params: {
        partner_id: this.partner_id.toString(),
        staff_id: staff.id.toString(),
      },
    });
  }
}
